import { Component, Vue, Emit } from 'vue-property-decorator';
export default class NaviSerchnaviArea extends Vue {
  private name = 'NaviSerchnaviArea';
 }
